/**
 * File export image
 */

import paper from './paper.png';
import phone from './phone.png';
import people from './people.png';
import say from './say.png';

export const IMAGES = {
  paper,
  phone,
  people,
  say,
};
